<div class="mini-cart" (mouseenter)="hoverOpen()" (mouseleave)="hoverLeave()">
  <!-- The bag with the count and the word, on every page (empty cart = no badge). Click opens the panel;
       the href is for a middle click / new tab and for crawlers. -->
  <a class="cart-link"
     [attr.href]="URLS.cart"
     [class.has-items]="count > 0"
     [class.menu-open]="open"
     aria-haspopup="dialog"
     [attr.aria-expanded]="open"
     [attr.aria-label]="count > 0 ? 'Cart, ' + count + ' item' + (count === 1 ? '' : 's') : 'Cart'"
     (click)="toggle($event)">
    <span class="cart-icon-wrap">
      <app-icon name="cart-shopping" class="cart-icon" aria-hidden="true"></app-icon>
      <span class="cart-count" *ngIf="count > 0" aria-hidden="true">{{ count }}</span>
    </span>
    <span class="cart-label">Cart</span>
  </a>

  <!-- The panel: the lines (three at a time), the subtotal, the way to the cart -->
  <div class="mini-cart-panel" *ngIf="open" role="dialog" aria-label="Your cart">
    <div class="mini-cart-head">
      <span class="mini-cart-title">Your cart</span>
      <span class="mini-cart-count" *ngIf="count > 0">{{ count }} {{ count === 1 ? 'item' : 'items' }}</span>
    </div>

    <ul class="mini-cart-rows" *ngIf="rows.length > 0">
      <li class="mini-cart-row" *ngFor="let row of rows; trackBy: trackBySku" [class.just-added]="row.sku === highlightSku">
        <img class="mini-cart-logo" *ngIf="row.logo" [src]="row.logo" alt="" width="40" height="40"/>
        <span class="mini-cart-text">
          <span class="mini-cart-name">{{ row.name }}</span>
          <span class="mini-cart-platform" *ngIf="row.platform">{{ row.platform }}</span>
        </span>
        <span class="mini-cart-amounts">
          <span class="mini-cart-price">{{ row.priceLabel || '' }}</span>
          <span class="mini-cart-quantity" *ngIf="row.quantity > 1">× {{ row.quantity }}</span>
        </span>
      </li>
    </ul>

    <p class="mini-cart-empty" *ngIf="rows.length === 0">Your cart is empty.</p>

    <div class="mini-cart-foot">
      <span class="mini-cart-subtotal" *ngIf="rows.length > 0">
        <span class="mini-cart-subtotal-label">Subtotal</span>
        <span class="mini-cart-subtotal-value">{{ subtotalLabel || '' }}</span>
      </span>
      <a class="codigrate-button mini-cart-cta" *ngIf="rows.length > 0" [attr.href]="URLS.cart" (click)="go(URLS.cart, $event)"><p>Go to cart</p></a>
      <a class="codigrate-button mini-cart-cta" *ngIf="rows.length === 0" [attr.href]="URLS.themes" (click)="go(URLS.themes, $event)"><p>Browse themes</p></a>
    </div>
  </div>
</div>
